import React from 'react'
import {
	Container,
	Arrow,
	TitleText,
	ValueText,
	TextCol,
} from './InfoWithlink.style'

interface InfoWithLinkProps {
	title: string;
	text: string;
	description?: boolean;
	onClick: () => any;
	style?: any,
}

const InfoWithLink = (props: InfoWithLinkProps) => {
	return (
		<Container {...props}>
			<TextCol>
				<TitleText>{props.title}</TitleText>
				<ValueText description={props.description}>{props.text}</ValueText>
			</TextCol>
			<Arrow />
		</Container>
	)
}

export default InfoWithLink
